module.exports = "/assets/2-yHSQ0HoQ.png";